// Scenario preset selector — Pessimistic / Mean / Optimistic.
// Drives `scenarioKey` state. Same shape used in header and inline contexts;
// `compact` shrinks for sticky header use.

const SCENARIOS = [
  { k: 'conservative', label: 'Pessimistic' },
  { k: 'base', label: 'Mean' },
  { k: 'bull', label: 'Optimistic' },
];

export default function ScenarioPills({ value, onChange, compact = false }) {
  return (
    <div
      role="radiogroup"
      aria-label="Forecast scenario"
      className={`inline-flex p-1 rounded-full bg-white border border-carbon-100 ${
        compact ? '' : 'shadow-sm'
      }`}
    >
      {SCENARIOS.map((o) => {
        const active = value === o.k;
        return (
          <button
            key={o.k}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => onChange(o.k)}
            className={`label rounded-full transition-all duration-200 outline-none focus-visible:ring-2 focus-visible:ring-ice-400 ${
              compact ? 'h-7 px-3.5' : 'h-9 px-5'
            } ${active ? 'bg-carbon-800 text-white' : 'text-carbon-500 hover:text-carbon-800'}`}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
